<template>
    <div>
        <div class="flex flex-justify-sb" :class="wrapperClasses">
            <div
                class="cabinet-product-detail-nav cabinet-product-detail-nav--suppliers flex flex-align-center"
            >
                <a
                    v-for="(tab, i) in tabs"
                    :key="i"
                    href="#"
                    class="cabinet-product-detail-nav__link cabinet-product-detail-nav__link--new"
                    :class="{ active: active === i }"
                    @click.prevent="setActive(i)"
                    >{{ tab }}</a
                >
            </div>
        </div>
        <slot></slot>
        <slot :name="active"></slot>
    </div>
</template>

<script>
export default {
    name: 'CabinetTabs',
    props: {
        // active: {
        //     type: Number,
        //     default: 0
        // },
        tabs: {
            type: Array,
            default: () => ['Tab-1', 'Tab-2']
        },
        wrapperClasses: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            active: 0
        }
    },
    methods: {
        setActive(i) {
            this.active = i
        }
    }
}
</script>
